<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter" />
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form ref="ruleForm">
          <div class="lg:mb-2">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('distributors.entity_name') }}</label>
                <el-form-item prop="distribuidor">
                  <base-el-select :options="distribuidores" v-model="form.distribuidor.value"
                    :option-listeners="{ select: handleSelectDistribuidor }" class="w-full" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
              </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="name">
                <el-input clearable class="w-full" v-model="form.name.value" maxlength="50" />
              </el-form-item>
            </div>
            <div v-if="isSuperAdminOrDistributor">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contact_email.entity_plural') }}</label>
              <el-form-item prop="EmailsContacto">
                <el-input clearable class="w-full" v-model="form.EmailsContacto.value" maxlength="50" />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.cod_ext') }}</label>
              <el-form-item prop="codigoExterno">
                <el-input clearable class="w-full" v-model="form.codigoExterno.value" maxlength="20" />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.serial_number') }}</label>
              <el-form-item prop="ns">
                <el-input clearable class="w-full" v-model="form.ns.value" maxlength="255" />
              </el-form-item>
            </div>

            <div v-if="role === 3">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.partner') }}</label>
              <el-form-item prop="partner">
                <base-el-select class="w-full" :options="partners" v-model="form.partner.value" :loading="loadingPartners" clearable filterable @change="onChangePartner" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.grupo_cliente') }}</label>
              <el-form-item prop="grupoClienteId">
                <base-el-select class="w-full" :options="gruposCliente" v-model="form.grupoCliente.value" :loading="loadingGruposCliente" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.service_type') }}</label>
              <el-form-item prop="tipoServicio">
                <base-el-select class="w-full" :options="tiposServicio" v-model="form.tipoServicio.value" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.factura_submenu.auto_paid') }}</label>
              <el-form-item prop="PagarAlContabilizar">
                <base-el-select class="w-full" :options="values" v-model="form.PagarAlContabilizar.value" clearable :placeholder="$t('clients.factura_submenu.auto_paid_yes_no')" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.active') }}</label>
              <el-form-item prop="activo">
                <base-el-select class="w-full" :options="values" v-model="form.activo.value" clearable :placeholder="$t('companies.active_yes_no')" />
              </el-form-item>
            </div>

            <div v-if="!disablePendienteEnviarFacturacion">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.filters.alta_fact_filter')}}</label>
              <el-form-item prop="PendienteFacturacion">
                <base-el-select class="w-full" :options="values" v-model="form.PendienteFacturacion.value" clearable :placeholder="$t('clients.filters.alta_fact_yes_no')" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.fase_config') }}</label>
              <el-form-item prop="FaseConfiguracion">
                <base-el-select class="w-full" :options="tiposFasesConfiguracion" v-model="form.FaseConfiguracion.value" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.paquete_contratacion') }}</label>
              <el-form-item prop="PaqueteContratacion">
                <base-el-select class="w-full" :options="tiposPaquetesContratacion" v-model="form.PaqueteContratacion.value" clearable filterable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.modulos_contratados') }}</label>
              <el-form-item prop="ModulosContratados">
                <base-el-select class="w-full" :options="tiposModulos" multiple v-model="form.ModulosContratados.value" clearable filterable />
              </el-form-item>
            </div>

            <div v-if="hasModuleSAML2">
              <AccessibleElSelect
                v-model="form.certificadoSAML2PorCaducar.value"
                prop="certificadoSAML2PorCaducar"
                :options="valuesForAccessibleSelect"
                :placeholder="$t('clients.certificadoSAML2PorCaducar_yes_no')"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.certificadoSAML2PorCaducar_filter')}}</template>
              </AccessibleElSelect>
            </div>

            <div v-if="hasModuleSAML2">
              <AccessibleElSelect
                v-model="form.certificadoSAML2Caducado.value"
                prop="certificadoSAML2Caducado"
                :options="valuesForAccessibleSelect"
                :placeholder="$t('clients.certificadoSAML2Caducado_yes_no')"
                id-prefix="clientsfilter"
              >
                <template slot="label">{{$t('clients.certificadoSAML2Caducado_filter')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"
        :loading="isLoading" />
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

import AccessibleElSelect from '@/components//elementui/AccessibleElSelect.vue'

import { getPartners } from '@/services/clients/getPartners'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect,
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'clients',
      isOpen: this.panelOpen,
      loadingDistribuidores: false,
      loadingGruposCliente: false,
      loadingPartners: false,
      links: [],
      form: {
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        name: { label: i18n.t('app.name'), value: '' },
        EmailsContacto: { label: i18n.t('contact_email.entity_plural'), value: '' },
        codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
        ns: { label: i18n.t('app.serial_number'), value: '' },
        partner: { label: i18n.t('clients.partner'), value: '', labelValue: '' },
        grupoCliente: { label: i18n.t('clients.grupo_cliente'), value: '', labelValue: '' },
        tipoServicio: { label: i18n.t('clients.service_type'), value: '', labelValue: '' },
        activo: { label: i18n.t('app.active'), value: '' },
        PagarAlContabilizar: { label: i18n.t('clients.factura_submenu.auto_paid'), value: '' },
        PendienteFacturacion: { label: i18n.t('clients.filters.alta_fact_filter'), value: '' },
        FaseConfiguracion: { label: i18n.t('clients.fase_config'), value: '' },
        PaqueteContratacion: { label: i18n.t('clients.paquete_contratacion'), value: '' },
        ModulosContratados: { label: i18n.t('clients.modulos_contratados'), value: '' },
        certificadoSAML2PorCaducar: { label: i18n.t('clients.certificadoSAML2PorCaducar_filter'), value: '' },
        certificadoSAML2Caducado: { label: i18n.t('clients.certificadoSAML2Caducado_filter'), value: '' }
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      partners: [],
      gruposCliente: [],
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    this.$store.dispatch('app/settiposServicio', this.tiposServicio)

    if (this.role === 3) {
      this.loadingDistribuidores = true
      const dataDistributors = await getDistributors()
      if (dataDistributors.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
      }
      this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
      this.loadingDistribuidores = false
  
      this.loadingPartners = true
      const dataClients = await getPartners()
      if (dataClients.blnError === false) {
        this.partners = dataClients.Partners.map(x => ({ value: x.IdPartner, label: x.Descripcion }))
        this.$store.dispatch('app/settiposPartners', dataClients.Partners)
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.loadingPartners = false
    }
    
    this.loadingGruposCliente = true
    const dataGruposCliente = await getClients({ grupoClientes: true })
    if (dataGruposCliente.blnError === false) {
      this.gruposCliente = dataGruposCliente.Clientes.map(x => ({ value: x.idCliente, label: x.Nombre }))
      this.$store.dispatch('app/settiposGruposClientes', dataGruposCliente.Clientes)
    } else {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataGruposCliente))
    }
    this.loadingGruposCliente = false
  },
  computed: {
    valuesForAccessibleSelect () {
      return this.values.map(item => ({ id: item.value, name: item.label }))
    },
    hasModuleSAML2 () {
      return !!this.$store.getters['auth/hasSAML2Module']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isSuperAdminOrDistributor: function () {
      return [3, 7, 8].includes(this.role)
    },
    disablePendienteEnviarFacturacion () {
      return (this.role === 8 || this.role === 7) &&
      this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 2
    },
    isLoading: function () {
      return this.$store.getters.isLoading || this.loadingPartners || this.loadingGruposCliente || this.loadingServiceTypes || this.loadingDistribuidores
    },
    tiposServicio: function () {
      return this.$store.getters['config/TIPOS_SERVICIO']
    },
    tiposPaquetesContratacion () {
      return this.$store.getters['config/TIPOS_PAQUETES_CONTRATACION']
    },
    tiposModulos () {
      return this.$store.getters['config/MODULOS']
    },
    tiposFasesConfiguracion () {
      return this.$store.getters['config/TIPOS_FASES_CONFIGURACION']
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.EmailsContacto.value = _temp.EmailsContacto !== undefined && _temp.EmailsContacto.value !== '' ? _temp.EmailsContacto.value : ''
        this.form.codigoExterno.value = _temp.codigoExterno !== undefined && _temp.codigoExterno.value !== '' ? _temp.codigoExterno.value : ''
        this.form.ns.value = _temp.ns !== undefined && _temp.ns.value !== '' ? _temp.ns.value : ''
        this.form.partner.value = _temp.partner !== undefined && _temp.partner.value !== '' ? _temp.partner.value : ''
        this.form.grupoCliente.value = _temp.grupoCliente !== undefined && _temp.grupoCliente.value !== '' ? _temp.grupoCliente.value : ''
        this.form.tipoServicio.value = _temp.tipoServicio !== undefined && _temp.tipoServicio.value !== '' ? _temp.tipoServicio.value : ''
        this.form.PagarAlContabilizar.value = _temp.PagarAlContabilizar !== undefined && _temp.PagarAlContabilizar.value !== '' ? _temp.PagarAlContabilizar.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.PendienteFacturacion.value = _temp.PendienteFacturacion !== undefined && _temp.PendienteFacturacion.value !== '' ? _temp.PendienteFacturacion.value : ''
        this.form.FaseConfiguracion.value = _temp.FaseConfiguracion !== undefined && _temp.FaseConfiguracion.value !== '' ? _temp.FaseConfiguracion.value : ''
        this.form.PaqueteContratacion.value = _temp.PaqueteContratacion !== undefined && _temp.PaqueteContratacion.value !== '' ? _temp.PaqueteContratacion.value : ''
        this.form.ModulosContratados.value = _temp.ModulosContratados !== undefined && _temp.ModulosContratados.value !== '' ? _temp.ModulosContratados.value : ''
        this.form.certificadoSAML2PorCaducar.value = _temp.certificadoSAML2PorCaducar !== undefined && _temp.certificadoSAML2PorCaducar.value !== '' ? _temp.certificadoSAML2PorCaducar.value : ''
        this.form.certificadoSAML2Caducado.value = _temp.certificadoSAML2Caducado !== undefined && _temp.certificadoSAML2Caducado.value !== '' ? _temp.certificadoSAML2Caducado.value : ''
      }
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        name: { label: i18n.t('app.name'), value: '' },
        EmailsContacto: { label: i18n.t('contact_email.entity_plural'), value: '' },
        codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
        ns: { label: i18n.t('app.serial_number'), value: '' },
        partner: { label: i18n.t('clients.partner'), value: '', labelValue: '' },
        grupoCliente: { label: i18n.t('clients.grupo_cliente'), value: '', labelValue: '' },
        tipoServicio: { label: i18n.t('clients.service_type'), value: '', labelValue: '' },
        activo: { label: i18n.t('app.active'), value: '' },
        PagarAlContabilizar: { label: i18n.t('clients.factura_submenu.auto_paid'), value: '' },
        PendienteFacturacion: { label: i18n.t('clients.filters.alta_fact_filter'), value: '' },
        FaseConfiguracion: { label: i18n.t('clients.fase_config'), value: '' },
        PaqueteContratacion: { label: i18n.t('clients.paquete_contratacion'), value: '' },
        ModulosContratados: { label: i18n.t('clients.modulos_contratados'), value: '' },
        certificadoSAML2PorCaducar: { label: i18n.t('clients.certificadoSAML2PorCaducar_filter'), value: '' },
        certificadoSAML2Caducado: { label: i18n.t('clients.certificadoSAML2Caducado_filter'), value: '' }
      }
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    applyFilters: function () {
      if (this.form.partner.value !== '') this.controlLabelPartner(this.form.partner.value)
      if (this.form.grupoCliente.value !== '') this.controlLabelgrupoCliente(this.form.grupoCliente.value)
      if (this.form.tipoServicio.value !== '') this.controlLabelTipoServicio(this.form.tipoServicio.value)
      if (this.form.FaseConfiguracion.value !== '') this.controlLabelFaseConfiguracion(this.form.FaseConfiguracion.value)
      if (this.form.PaqueteContratacion.value !== '') this.controlLabelPaqueteContratacion(this.form.PaqueteContratacion.value)
      if (!this.form.ModulosContratados.value?.length) this.form.ModulosContratados.value = ''
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    onChangePartner: function (value) {
    },
    onChangeTipoServicio: function (value) {
    },
    controlLabelgrupoCliente: function (value) {
      const grupoCliente = this.gruposCliente.filter(x => x.value === value)
      if (grupoCliente !== null && grupoCliente !== undefined) this.form.grupoCliente.labelValue = grupoCliente[0].label
    },
    controlLabelPartner: function (value) {
      const partner = this.partners.filter(x => x.value === value)
      if (partner !== null && partner !== undefined) this.form.partner.labelValue = partner[0].label
    },
    controlLabelTipoServicio: function (value) {
      const tipoServicio = this.tiposServicio.filter(x => x.id === value)
      if (tipoServicio !== null && tipoServicio !== undefined) this.form.tipoServicio.labelValue = tipoServicio[0].name
    },
    controlLabelFaseConfiguracion: function (value) {
      const FaseConfiguracion = this.tiposFasesConfiguracion.filter(x => x.id === value)
      if (FaseConfiguracion !== null && FaseConfiguracion !== undefined) this.form.FaseConfiguracion.labelValue = FaseConfiguracion[0].name
    },
    controlLabelPaqueteContratacion: function (value) {
      const PaqueteContratacion = this.tiposPaquetesContratacion.filter(x => x.id === value)
      if (PaqueteContratacion !== null && PaqueteContratacion !== undefined) this.form.PaqueteContratacion.labelValue = PaqueteContratacion[0].name
    }
  }
}
</script>

<style lang="scss" scoped></style>
